module.exports = __webpack_public_path__ + "static/media/NokiaPureTWeb_Rg.536160e8.ttf";